import SessionStore from 'stores/shared/session';
import ApiService from '../api';

export default {
  decline(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/reject`,
      method: 'PUT',
      params: { reason: params.reason, ...SessionStore._getCSRFTokenObject() },
    });
  },

  accept(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/accept`,
      method: 'PUT',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  cancel(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/cancel`,
      method: 'PUT',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  show(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}`,
    });
  },

  update(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}`,
      method: 'PUT',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  invoiceGuest(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.booking.id}`,
      method: 'PATCH',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  loadPricing({ id }) {
    return ApiService.fetch({
      url: `/api/bookings/${id}/pricing.json`,
      params: {},
    });
  },

  priceBreakdown(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.booking_id}/price_breakdown`,
      params: { paid_offline: params.paid_offline },
      force: true,
    });
  },

  pricePreview(params) {
    return ApiService.fetch({
      url: '/api/pricing/booking_preview',
      method: 'POST',
      json: true,
      params,
    });
  },

  sendMessage(params) {
    if (
      params.origin_location === 'feedback' ||
      params.origin_location === 'topic details'
    ) {
      const { feedbackId } = params;
      return ApiService.fetch({
        url: `/api/feedbacks/${feedbackId}/messages.json`,
        method: 'POST',
        params: { ...params, ...SessionStore._getCSRFTokenObject() },
      });
    }
    return ApiService.fetch({
      url: `/api/users/${params.guest_id}/message`,
      method: 'POST',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  alter(params) {
    const bookingParams = {
      booking: {
        date: params.date,
        time: params.time,
      },
      new_payment_data: params.new_payment_data,
    };
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/alter`,
      method: 'PUT',
      json: true,
      params: {
        ...bookingParams,
        ...SessionStore._getCSRFTokenObject(),
      },
    });
  },

  updateGuest(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/update_tourist`,
      method: 'PUT',
      params: { ...params, ...SessionStore._getCSRFTokenObject() },
    });
  },

  updateAdditionalGuests(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/update_additional_guests`,
      method: 'PUT',
      json: true,
      params: {
        ...params,
        ...SessionStore._getCSRFTokenObject(),
      },
    });
  },

  removeGuests(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/guests`,
      method: 'DELETE',
      json: true,
      params: {
        guest_ids: params.guests_to_delete,
        ...SessionStore._getCSRFTokenObject(),
      },
    });
  },

  addGuests(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/guests`,
      method: 'POST',
      json: true,
      params: {
        additional_guests: params.guests_to_add,
        ...SessionStore._getCSRFTokenObject(),
      },
    });
  },

  updateGuests(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.id}/guests`,
      method: 'PUT',
      json: true,
      params: {
        additional_guests: params.guests_to_update,
        ...SessionStore._getCSRFTokenObject(),
      },
    });
  },

  sendNotification(params) {
    return ApiService.fetch({
      url: `/api/bookings/${params.booking_id}/send_notification`,
      params: { mailer_method: params.mailer_method },
      force: true,
    });
  },

  fetchPayments(bookingId) {
    return ApiService.fetch({
      method: 'GET',
      url: `/api/bookings/${bookingId}/payments`,
    });
  },
};
